import { Globe2 } from "lucide-react";

export const isAbroad = (phone, flag) => !!flag || (!!phone && !String(phone).startsWith("+55"));

export const AbroadTag = ({ testid, big }) => (
  <span data-testid={testid} title="Cliente fora do Brasil: usar o servidor http://Rtext.vip"
    className={`inline-flex items-center gap-1 rounded bg-fuchsia-500/15 font-bold uppercase text-fuchsia-300 ${big ? "px-2 py-0.5 text-[11px]" : "px-1.5 text-[10px]"}`}>
    <Globe2 className={big ? "h-3.5 w-3.5" : "h-3 w-3"} /> Fora do Brasil
  </span>
);
